import { ScannerConfig, RefreshInterval } from './entities';
import { DEFAULT_SCANNER_CONFIG, DEFAULT_SCANNER_FILTERS } from './scannerPreset';

const defaultSubtypeFilter = DEFAULT_SCANNER_FILTERS.find(
  filter => filter.field === 'subtype' && filter.operator === 'in',
);

/** Subtype parameters in the basic / Edge-screener-parity preset ({@link DEFAULT_SCANNER_FILTERS}). */
export const BASIC_SCANNER_SUBTYPE_IDS = defaultSubtypeFilter?.parameters ?? [];

/** Column colIds in the basic scanner preset ({@link DEFAULT_SCANNER_CONFIG}). */
export const BASIC_SCANNER_COLUMN_IDS = DEFAULT_SCANNER_CONFIG.tableParameters.columns
  .filter(column => !column.hide)
  .map(column => column.colId);

/** Refresh intervals that keep basic-scanner grid access (default 1m + manual never). */
export const BASIC_SCANNER_REFRESH_INTERVALS = [DEFAULT_SCANNER_CONFIG.refreshInterval, RefreshInterval.Never] as const;

const BASIC_SCANNER_COLUMN_SET = new Set<string>(BASIC_SCANNER_COLUMN_IDS);
const BASIC_SCANNER_SUBTYPE_SET = new Set<string>(BASIC_SCANNER_SUBTYPE_IDS);
const BASIC_SCANNER_REFRESH_INTERVAL_SET = new Set<number>(BASIC_SCANNER_REFRESH_INTERVALS);

/** Edge screener parity: preset filters, columns, and refresh interval (no IAM required). */
export function isBasicScannerConfiguration(
  config: Pick<ScannerConfig, 'filters' | 'tableParameters' | 'refreshInterval'>,
): boolean {
  return (
    config.filters.every(
      filter =>
        filter.field === 'subtype' &&
        filter.operator === 'in' &&
        filter.parameters.every(parameter => BASIC_SCANNER_SUBTYPE_SET.has(parameter)),
    ) &&
    config.tableParameters.columns.every(column => BASIC_SCANNER_COLUMN_SET.has(column.colId)) &&
    BASIC_SCANNER_REFRESH_INTERVAL_SET.has(config.refreshInterval)
  );
}
